module.exports = __webpack_public_path__ + "img/1-04.6d116250.svg";